import * as React from 'react';

/**
 *
 * IspViewOption component
 * @extends {React.PureComponent<IIspSerpProps<IIspSerpData>>}
 */
class IspViewOption extends React.Component <IAppProps, IAppState> {
    /* tslint:disable:no-string-literal */
    public handleOnClick = (event: React.MouseEvent<HTMLElement>) => {
        if (window['isp_switch_mode'] !== undefined) {
            window['isp_switch_mode'](event.currentTarget.dataset.arg);
        }
    }
    /* tslint:enable:no-string-literal */

    public render(): JSX.Element | null {
        return (
            <>
                <a
                    role='button'
                    data-arg={this.props.code}
                    className='isp_view_mode_button'
                    title={this.props.title}
                    id={this.props.id}
                    onClick={this.handleOnClick}
                >
                    <img src={this.props.image} style={{marginRight: '0.1em'}} alt={this.props.alt}/>
                </a>
            </>
        );
    }
}

interface IAppProps {
    id: string;
    title: string;
    image: string;
    code: number;
    alt: string;
}

interface IAppState {
    name: string;
}

export default IspViewOption;